import api from './api';

const base = (venueId: string, wineListId: string) =>
  `/admin/venue/${venueId}/wine-list/${wineListId}/share`;

export interface WineListShare {
  _id: string;
  venueId: string;
  wineListId: string;
  slug: string;
  token: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

const wineListShareService = {
  /**
   * Returns the most recent active share for the wine list. Resolves to null
   * when none exists (the API returns 404 in that case — we map it to null
   * so callers don't have to discriminate).
   */
  getShare: async (venueId: string, wineListId: string): Promise<WineListShare | null> => {
    try {
      const response = await api.get(base(venueId, wineListId));
      return response.data;
    } catch (err: any) {
      if (err?.response?.status === 404) return null;
      throw err;
    }
  },

  /** Idempotent — returns the existing active share or creates a new one. */
  createShare: async (venueId: string, wineListId: string): Promise<WineListShare> => {
    const response = await api.post(base(venueId, wineListId));
    return response.data;
  },

  /** Soft-revoke. The slug stays reserved; recreating yields a new slug. */
  revokeShare: async (venueId: string, wineListId: string): Promise<void> => {
    await api.delete(base(venueId, wineListId));
  },
};

export default wineListShareService;
